import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import překladových souborů
import commonCs from '../locales/cs/common.json';
import commonEn from '../locales/en/common.json';

// Konfigurace i18next
i18n
  // Detekce jazyka
  .use(LanguageDetector)
  // React bindings
  .use(initReactI18next)
  // Inicializace
  .init({
    // Překladové resources
    resources: {
      cs: {
        common: commonCs,
      },
      en: {
        common: commonEn,
      },
    },

    // Výchozí namespace
    defaultNS: 'common',
    
    // Namespaces
    ns: ['common'],

    // Fallback jazyk
    fallbackLng: 'cs',

    // Detekce jazyka
    detection: {
      // Pořadí detekce
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Klíč pro localStorage
      lookupLocalStorage: 'i18nextLng',
      
      // Cache jazyk v localStorage
      caches: ['localStorage'],
      
      // Nikdy nepoužívat cached jazyk
      excludeCacheFor: ['cimode'],
    },

    // Interpolace
    interpolation: {
      escapeValue: false, // React už escapeuje hodnoty
    },

    // Debug mód (pouze v development)
    debug: true, // Zatím zapnuto pro debug

    // React specifické nastavení
    react: {
      useSuspense: false, // Nepoužívat Suspense pro i18next
    },

    // Inicializace
    initImmediate: false,

    // Namespace separátor
    nsSeparator: ':',
    keySeparator: '.',

    // Pluralizace
    pluralSeparator: '_',
    contextSeparator: '_',
  });

export default i18n; 